import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Papa from "papaparse";
import Home from "./components/Home";
import Exercises from "./components/Exercises";
import ExerciseDetails from "./components/ExerciseDetails";
import Legal from "./components/Legal";
import "./App.css";
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';

const App = () => {
  const [data, setData] = useState([]);

  // CSV-Daten laden
  useEffect(() => {
    Papa.parse("/exercises.csv", {
      download: true,
      header: true,
      complete: (results) => {
        setData(results.data);
      },
      error: (error) => {
        console.error("Fehler beim Laden der CSV-Datei:", error);
      },
    });
  }, []);

  return (
    <Router>
      <div>
        {/* Navigationsleiste */}
        <nav className="navbar">
          <NavLink to="/" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Home
          </NavLink>
          <NavLink to="/exercises" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Übungen
          </NavLink>
          <NavLink to="/blog" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Blog
          </NavLink>
          <NavLink to="/legal" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Rechtliches
          </NavLink>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/exercises" element={<Exercises data={data} />} />
          <Route path="/details/:id" element={<ExerciseDetails data={data} />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/legal" element={<Legal />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
